import * as React from 'react';
import ArrowLeftOutlined from './arrow-left-outlined';
import ArrowLeftFilled from './arrow-left-filled';
import type { IconCombinedProps } from './types';
const ArrowLeftCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowLeftFilled ref={ref} {...rest} />;
  }
  return <ArrowLeftOutlined ref={ref} {...rest} />;
});
export default ArrowLeftCombined;